import { APP_ROUTES } from '@/routes';
import type { RegisterFormType } from '../schemas';
import { useAuthMutations } from './mutations';
import { useRouter } from 'next/navigation';
import { useToast } from '@packages/chakra-v3';

const useRegister = () => {
	const router = useRouter();
	const { showError, showSuccess } = useToast();
	const { registerMutation } = useAuthMutations();

	const handleGoBack = () => router.back();

	const handleRegisterUserSuccess = () => {
		router.replace(APP_ROUTES.AUTH.LOGIN);
		showSuccess({
			title:       'Registration successful',
			description: 'Please login to continue',
		});
	};

	const handleRegisterUserError = () => {
		showError({
			title:       'Registration failed',
			description: 'Please try again',
		});
	};

	const handleRegisterUser = async(registerFormData: RegisterFormType) => {
		await registerMutation.mutateAsync(
			{ body: registerFormData },
			{
				onSuccess: handleRegisterUserSuccess,
				onError:   handleRegisterUserError,
			},
		);
	};

	return {
		handleRegisterUser,
		handleGoBack,
	};
};

export default useRegister;